import React from 'react';

/**
 * TuFilaLogo - Premium SVG Logo Component
 * Recreated from user-provided design reference.
 * Includes SVG filters for high-end glowing effects.
 */
const TuFilaLogo = ({ className, size = 400 }) => {
    return (
        <svg 
            width={size} 
            height={size * 0.75} 
            viewBox="0 0 400 300" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <defs>
                {/* Glow Filter for the first pill */}
                <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="15" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
                
                {/* Inner shadow/gradient for pill texture */}
                <linearGradient id="pillGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#ff1b6b" />
                    <stop offset="100%" stopColor="#45caff" />
                </linearGradient>
            </defs>

            {/* Pill 1 - The Active/Glowing one */}
            <g filter="url(#glow)">
                <rect x="50" y="50" width="80" height="200" rx="40" fill="#ff0080" />
                <text 
                    x="90" 
                    y="165" 
                    textAnchor="middle" 
                    fill="white" 
                    style={{ fontSize: '48px', fontWeight: 'bold', fontFamily: 'Inter, system-ui' }}
                >
                    01
                </text>
            </g>

            {/* Pill 2 */}
            <rect x="140" y="60" width="60" height="180" rx="30" fill="#301934" opacity="0.8" />

            {/* Pill 3 */}
            <rect x="210" y="60" width="60" height="180" rx="30" fill="#8a2be2" opacity="0.6" />

            {/* Pill 4 */}
            <rect x="280" y="60" width="60" height="180" rx="30" fill="#b19cd9" opacity="0.4" />
        </svg>
    );
};

export default TuFilaLogo;
